import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { Logger } from '../generic/logging/default-log.service';
import { BaseService } from '../generic/service/base.service';
import { HttpClient } from '../generic/service/http.service';
import { ConfigurationHelper } from '../generic/helper/configuration.helper';
import { Claim } from '../generic/classes/claim';
import { ClaimResponse } from '../generic/classes/claim.response';
import { ClaimShipmentLine } from '../generic/classes/claim.shipment.line';
import { ClaimCategory } from '../generic/classes/claim.category';
import { ClaimSolution } from '../generic/classes/claim.solution';
import { PaginationData } from '../components/filters/pagination.data';

/**
 * Claim service
 */
@Injectable()
export class ClaimService extends BaseService {
    private http = inject(HttpClient);

    constructor() {
        const logger = inject(Logger);

        super(logger);
    }

    getClaimsForUser(page: number): Observable<PaginationData<Claim>> {
        const url = ConfigurationHelper.getWebshopUrl(
            `/rest/claims?page=${page}`,
        );
        return this.http.get<PaginationData<Claim>>(url);
    }

    getClaim(claimId: string): Observable<ClaimResponse> {
        const url = ConfigurationHelper.getWebshopUrl(
            `/rest/claims/${claimId}`,
        );
        return this.http.get<ClaimResponse>(url);
    }

    getClaimableShipmentLines(): Observable<ClaimShipmentLine[]> {
        const url = ConfigurationHelper.getWebshopUrl(
            '/rest/claims/shipmentlines',
        );
        return this.http.get<ClaimShipmentLine[]>(url);
    }

    getClaimCategories(): Observable<ClaimCategory[]> {
        const url = ConfigurationHelper.getWebshopUrl(
            '/rest/claims/categories',
        );
        return this.http.get<ClaimCategory[]>(url);
    }

    getClaimSolutions(): Observable<ClaimSolution[]> {
        const url = ConfigurationHelper.getWebshopUrl('/rest/claims/solutions');
        return this.http.get<ClaimSolution[]>(url);
    }

    submitClaim(claimFormData): Observable<ClaimResponse> {
        const url = ConfigurationHelper.getWebshopUrl('/rest/claims/insert');
        return this.http.post(url, claimFormData, true);
    }
}
